import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './TeamSelection.css';

const teams = [
  {
    id: 'red_bull',
    name: 'Red Bull Racing',
    image: '/images/redbull.png',
    color: '#0600EF',
    description: 'The reigning champions'
  },
  {
    id: 'ferrari',
    name: 'Scuderia Ferrari',
    image: '/images/ferrari.png',
    color: '#DC0000',
    description: 'The Prancing Horse'
  },
  {
    id: 'mercedes',
    name: 'Mercedes-AMG',
    image: '/images/mercedes.png',
    color: '#00D2BE',
    description: 'Silver Arrows'
  },
  {
    id: 'mclaren',
    name: 'McLaren',
    image: '/images/mclaren.png',
    color: '#FF8700',
    description: 'The Papaya Army'
  },
  {
    id: 'aston_martin',
    name: 'Aston Martin',
    image: '/images/astonmartin.png',
    color: '#006F62',
    description: 'Racing Green'
  },
  {
    id: 'alpine',
    name: 'Alpine',
    image: '/images/alpine.png',
    color: '#0090FF',
    description: 'French Excellence'
  },
  {
    id: 'williams',
    name: 'Williams',
    image: '/images/williams.png',
    color: '#005AFF',
    description: 'Historic Legacy'
  },
  {
    id: 'rb',
    name: 'RB',
    image: '/images/visacashapp.png',
    color: '#6692FF',
    description: 'Sister Team'
  },
  {
    id: 'kick_sauber',
    name: 'Kick Sauber',
    image: '/images/kicksauber.png',
    color: '#00E701',
    description: 'Swiss Precision'
  },
  {
    id: 'haas',
    name: 'Haas F1',
    image: '/images/haas.png',
    color: '#FFFFFF',
    description: 'American Spirit'
  }
];

const TeamSelection = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hoveredTeam, setHoveredTeam] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleTeamSelect = (team) => {
    setSelectedTeam(team);
  };

  const handleConfirm = async () => {
    if (!selectedTeam || !user) return;

    setLoading(true);
    try {
      // Update user's favorite team in Firestore
      const userRef = doc(db, 'users', user.uid);
      await updateDoc(userRef, {
        favoriteTeam: selectedTeam.id,
        favoriteTeamName: selectedTeam.name,
        favoriteTeamImage: selectedTeam.image,
        teamSelected: true,
        updatedAt: new Date()
      });

      console.log('✅ Team saved:', selectedTeam.name);

      // Force reload the page to refresh the auth context
      window.location.href = '/dashboard';
    } catch (error) {
      console.error('Error saving team:', error);
      alert('Failed to save team selection. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="team-selection-page">
      {/* Background Video */}
      <video className="team-selection-video-bg" autoPlay loop muted playsInline>
        <source src="/videos/f1-race.mp4" type="video/mp4" />
      </video>
      <div className="team-selection-overlay"></div>

      {/* Content */}
      <div className="team-selection-container">
        {/* Header */}
        <div className="team-selection-header">
          <div className="header-badge">
            <span className="badge-icon">🏎️</span>
            <span>Choose Your Team</span>
          </div>
          <h1 className="selection-title">
            Pick Your Favorite
            <br />
            <span className="gradient-text">F1 Team</span>
          </h1>
          <p className="selection-subtitle">
            Your choice will personalize your dashboard experience
          </p>
        </div>

        {/* Teams Grid */}
        <div className="teams-grid">
          {teams.map((team) => (
            <div
              key={team.id}
              className={`team-card ${selectedTeam?.id === team.id ? 'selected' : ''} ${hoveredTeam === team.id ? 'hovered' : ''}`}
              onClick={() => handleTeamSelect(team)}
              onMouseEnter={() => setHoveredTeam(team.id)}
              onMouseLeave={() => setHoveredTeam(null)}
            >
              <div className="team-card-inner">
                <div className="team-image-wrapper">
                  <img 
                    src={team.image} 
                    alt={team.name}
                    className="team-image"
                  />
                  {selectedTeam?.id === team.id && (
                    <div className="selected-badge">
                      <span className="checkmark">✓</span>
                    </div>
                  )}
                </div>
                <div className="team-info">
                  <h3 className="team-name">{team.name}</h3>
                  <p className="team-description">{team.description}</p>
                </div>
                <div 
                  className="team-accent"
                  style={{ background: team.color }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        {/* Confirm Button */}
        {selectedTeam && (
          <div className="confirm-section">
            <button 
              className="confirm-btn"
              onClick={handleConfirm}
              disabled={loading}
            >
              <span>{loading ? 'Saving...' : `Continue with ${selectedTeam.name}`}</span>
              {!loading && <span className="btn-arrow">→</span>}
            </button>
          </div>
        )}

        {/* Skip Option */}
        <div className="skip-section">
          <button 
            className="skip-btn"
            onClick={() => navigate('/dashboard')}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamSelection;

